import React from "react";
import { WcStack, WcButton, WcTypography } from "@bpipartners/webui";
import { useTranslations } from "next-intl";
import { ForgotPasswordForm, ForgotPasswordFormState } from "../../forms/login";
import { useTheme } from "@guberno/utils/theme";

export interface ForgotPasswordFormCompositeProps {
  onForgotPasswordDetails: (val: ForgotPasswordFormState) => void;
  forgotRef: React.RefObject<any>;
  failedReset: boolean;
  handleForgotClicked: () => void;
}

const ForgotPasswordFormComposite = ({
  onForgotPasswordDetails,
  forgotRef,
  failedReset,
  handleForgotClicked,
}: ForgotPasswordFormCompositeProps) => {
  const t = useTranslations("login");
  const theme = useTheme();
  return (
    <WcStack width="100%" gap={5} alignItems="center">
      <WcTypography sx={{ textAlign: "center" }}>
        {t("fillDetailsForgotPassword")}
      </WcTypography>
      {failedReset && (
        <WcTypography
          variant="body1"
          color={theme.appColors.error}
          sx={{ textAlign: "center" }}
        >
          {t("failedPaswordReset")}
        </WcTypography>
      )}
      <WcStack justifyContent={"center"} alignItems="center" width="100%">
        <ForgotPasswordForm
          onForgotPasswordDetails={onForgotPasswordDetails}
          ref={forgotRef}
        />
      </WcStack>

      <WcStack>
        <WcStack alignItems={"center"}>
          <WcButton
            color="primary"
            variant="contained"
            onClick={handleForgotClicked}
          >
            {t("resetPassword")}
          </WcButton>
        </WcStack>
      </WcStack>
    </WcStack>
  );
};

export default ForgotPasswordFormComposite;
